import React from 'react';

const UserIcon = ({ color }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4235 9.44756V7.30056C16.4235 4.78756 14.3855 2.74956 11.8725 2.74956C9.35949 2.73856 7.31349 4.76656 7.30249 7.28056V7.30056V9.44756"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6832 21.2495H8.04224C5.94824 21.2495 4.25024 19.5525 4.25024 17.4575V13.1685C4.25024 11.0735 5.94824 9.37646 8.04224 9.37646H15.6832C17.7772 9.37646 19.4752 11.0735 19.4752 13.1685V17.4575C19.4752 19.5525 17.7772 21.2495 15.6832 21.2495Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.863 14.2026V16.4236"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UserIcon;
